import { Injectable } from '@angular/core';

import { BehaviorSubject } from 'rxjs';
import { SubNavigation, TopLevelNavItem } from './models';
import { ContentService } from '@src/app/shared/content';

@Injectable({
    providedIn: 'root',
})
export class NavigationService {
    constructor() {}

    openDropdownId!: string | null;
    dropdownTriggeredByClick: boolean = false;

    topLevel!: TopLevelNavItem[];
    dropDowns!: SubNavigation[];

    private navPanelState = new BehaviorSubject<boolean>(false);
    navPanelState$ = this.navPanelState.asObservable();

    async load(contentService: ContentService): Promise<void> {
        // Return early if already loaded to avoid duplicate fetches
        if (this.topLevel !== undefined && this.dropDowns !== undefined) {
            return;
        }

        const [topLevel, dropDowns] = await Promise.all([
            contentService.getComponentP(
                'navigation-top-level',
                undefined,
                true,
            ),
            contentService.getComponentP(
                'navigation-drop-downs',
                undefined,
                true,
            ),
        ]);

        this.topLevel = topLevel || [];
        this.dropDowns = dropDowns || [];
    }

    dropdownClick(dropdownId: string) {
        if (
            this.dropdownTriggeredByClick &&
            this.openDropdownId === dropdownId
        ) {
            this.clearDropdown();
        } else {
            this.dropdownTriggeredByClick = true;
            this.openDropdownId = dropdownId;
        }
    }

    dropdownHover(dropdownId: string) {
        if (
            !this.dropdownTriggeredByClick &&
            this.openDropdownId !== dropdownId
        ) {
            this.openDropdownId = dropdownId;
        }
    }

    clearDropdown() {
        this.openDropdownId = null;
        this.dropdownTriggeredByClick = false;
    }

    setNavPanelState(state: boolean): void {
        this.navPanelState.next(state);
    }

    handleNavPanelChanges(element: HTMLElement): void {
        const hasClass = element.classList.contains('show');
        this.setNavPanelState(hasClass);
        if (hasClass) {
        } else {
        }
    }
}
